// folders with their first few articles, enough to tell whether anything is saved
// (deleted articles are dropped by the API, so one slot could be empty); 404 = no folders yet
export const fetchSavedFolders = async () => {
  const response = await fetch("/api/users/articles?skip=0&limit=10")
  if (response.status === 404) {
    return []
  }
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  return response.json()
}

export const hasSavedItems = (folders) => folders.some((folder) => folder.items?.some(Boolean))
